import { IPrescription } from '../interface/iprescription';
export class Prescription implements IPrescription {
    constructor(public PatientId : number,
        public DrugsName : string,
        public DrugStrength : string,
        public DrugDuration : number,
        public DrugRange : string,
        public DrugTime1 : number,
        public DrugTime2 : number,
        public DrugTime3: number,
        public IsBeforeMeal: boolean,
        public IsAfterMeal: boolean,
        public DrugInstruction : string,
        public AppointmentDay : string,
        public AppointmentTime : string,
        public AppointmentId: number, public PrescriptionAutoId?: number, public DrugsType? : string,
        public DrugsGenericName? : string, public Is2BeforeMeal?: boolean,
        public Is2AfterMeal?: boolean, public Is3BeforeMeal?: boolean,
        public Is3AfterMeal?: boolean, public PrescriptionPath?: string){}
}

export class MAppointmentAfterCall {
    constructor( public AppointmentId: number,
    public PatientId: number,
    public AppointmentDay: string,
    public AppointmentTime: string,
    public FollowUp: string,
    public PatientNeed: string,
    public Comment: string,
    public Invetigation: string,
    public Diagnosis: string,
    public Recommendation: string,public Prescriptions: Array<Prescription>, public PrescriptionFiles: Array<any>) {

    }

}



// WEBPACK FOOTER //
// ./src/app/section/patient/model/prescription.ts